import { InlineCalendar } from "PFComponents/calendar/inline_calendar";
import { formatEndOfDay } from "PFCore/helpers/date";
import { useDateFormatter } from "PFCore/hooks";
import { CSSProperties, RefObject } from "react";

type ExpiryDateSelectorProps = {
  className?: string;
  value: string | null;
  onChange: (value: string | null) => void;
  label?: string;
  required?: boolean;
  error?: string;
  qaId?: string;
  portalRef?: React.RefObject<HTMLDivElement | null>;
  variant?: "default" | "table";
  disabled?: boolean;
  tabIndex?: number;
  style?: CSSProperties;
  inputRef?: RefObject<HTMLInputElement>;
};

export const ExpiryDateSelector = ({
  className,
  value,
  onChange,
  label,
  required,
  error,
  qaId,
  portalRef,
  variant,
  disabled,
  tabIndex,
  style,
  inputRef
}: ExpiryDateSelectorProps) => {
  const { formatISODate } = useDateFormatter();

  const today = new Date();
  const tomorrow = today.setDate(today.getDate() + 1);

  const handleChange = (date: string | null) => {
    if (!date) {
      onChange(null);
      return;
    }

    onChange(formatEndOfDay(date));
  };

  return (
    <InlineCalendar
      inputClassName={className}
      label={label}
      selectedDate={value ? formatISODate(value) : null}
      minDate={formatISODate(tomorrow)}
      qaId={qaId}
      error={error}
      handleChange={handleChange}
      style={{ ...style, maxWidth: 220 }}
      required={required}
      portalRef={portalRef}
      variant={variant}
      disabled={disabled}
      tabIndex={tabIndex}
      inputRef={inputRef}
    />
  );
};
